export enum ChangeRequestType {
  MODIFY = <any>'MODIFY',
  REPORTBY = <any>'REPORTBY'
}
